import React from 'react';
const RefundPage = () => {
  return <div className="container mx-auto px-4 py-12" data-id="element-337">
      <h1 className="text-3xl font-bold mb-8 text-[#1A2B4C]" data-id="element-338">Refund Policy</h1>
      <div className="bg-white rounded-lg shadow-sm p-8" data-id="element-339">
        <p className="mb-6" data-id="element-340">
          Thank you for choosing Elevatefix. We aim to ensure you are completely
          satisfied with our services. If you have any concerns about your
          service plan, we are committed to resolving them quickly and fairly.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-341">
          Cancellation & Refund Rights
        </h2>
        <p className="mb-6" data-id="element-342">
          You have the right to a full refund if you cancel your service plan
          within 14 days of purchase. Simply contact us within this period, and
          we will process your refund without delay.
          <br data-id="element-343" />
          <br data-id="element-344" />
          If you cancel after 14 days but within 28 days of purchase, you may
          still be eligible for a partial refund at our discretion, depending on
          any services already provided.
          <br data-id="element-345" />
          <br data-id="element-346" />
          Please note, we cannot offer refunds or cancellations after 28 days
          from your purchase date. We encourage you to contact us promptly if
          you wish to cancel.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-347">
          How to Request a Refund
        </h2>
        <p className="mb-6" data-id="element-348">
          To request a refund, please get in touch with our team using the
          contact details below. We will assess your request promptly and
          process any approved refunds. A confirmation will be sent to you once
          your refund is complete.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-349">
          Contact Information
        </h2>
        <p className="mb-6" data-id="element-350">
          Phone: 0800 055 4969
          <br data-id="element-351" />
          Customer Service Email: dronakoirala6@gmail.com
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-352">
          Payment Methods
        </h2>
        <p className="mb-6" data-id="element-353">
          Your 14-day cancellation right applies regardless of how you paid for
          your plan. Refunds will always be returned to the original payment
          method for security reasons. We cannot issue refunds to alternative
          accounts or cards.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-354">
          Dispute Resolution
        </h2>
        <p className="mb-4" data-id="element-355">
          If you have any issues with your payment or service, please contact
          Elevatefix first before initiating a chargeback with your bank. We are
          here to help and can usually resolve any concerns much faster and more
          fairly than a bank. Initiating a chargeback can often delay your
          refund.
        </p>
      </div>
    </div>;
};
export default RefundPage;